import {
    FETCH_ZONES,
    FETCH_ZONES_SUCCESS,
    FETCH_ZONES_FAILED,
    FETCH_CUSTOM_ROUTES,
    FETCH_CUSTOM_ROUTES_SUCCESS,
    FETCH_CUSTOM_ROUTES_FAILED
} from "../store/types";
import { firebase } from '../config/configureFirebase';
import { onValue } from "firebase/database";
import store from '../store/store';

export const fetchZones = () => (dispatch) => {
    const {
        zonesRef
    } = firebase;

    dispatch({
        type: FETCH_ZONES,
        payload: null
    });

    onValue(zonesRef, (snapshot) => {
        const val = snapshot.val();
        if (val) {
            dispatch({
                type: FETCH_ZONES_SUCCESS,
                payload: snapshot.val()
            });
        } else {
            dispatch({
                type: FETCH_ZONES_SUCCESS,
                payload: {}
            });
        }
    }, (error) => {
        dispatch({
            type: FETCH_ZONES_SUCCESS,
            payload: {}
        });
    });
};

export const fetchCustomRoutes = () => (dispatch) => {
    const {
        customRoutesRef
    } = firebase;

    dispatch({
        type: FETCH_CUSTOM_ROUTES,
        payload: null
    });

    onValue(customRoutesRef, (snapshot) => {
        const val = snapshot.val();
        if (val) {
            dispatch({
                type: FETCH_CUSTOM_ROUTES_SUCCESS,
                payload: snapshot.val()
            });
        } else {
            dispatch({
                type: FETCH_CUSTOM_ROUTES_SUCCESS,
                payload: {}
            });
        }
    }, (error) => {
        dispatch({
            type: FETCH_CUSTOM_ROUTES_SUCCESS,
            payload: {}
        });
    });
};
